var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRacingFlag = function SvgRacingFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.287 0h60.485v512H15.287zM356.368 210.413h70.154v70.154h-70.154zM286.214 140.259h70.154v70.154h-70.154zM216.06 210.413h70.154v70.154H216.06zM286.214 0h70.154v70.105h-70.154zM75.772 210.413h70.135v70.154H75.772z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.907 280.566h70.153v70.154h-70.153zM286.214 280.566h70.154v70.154h-70.154zM75.772 70.105h70.135v70.154H75.772zM145.907 0h70.154v70.105h-70.154zM356.368 70.105h70.154v70.154h-70.154zM216.06 70.105h70.154v70.154H216.06z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.907 140.259h70.154v70.154h-70.154zM496.675 140.259h-70.153v70.154h70.191zM496.713 0h-70.191v70.105h70.153zM496.713 280.566h-70.191v70.154l70.191.031z"
  })));
};
export default SvgRacingFlag;